<div class="junior-camps-header" *ngIf="juniorCampInfo">
  <lx-price-lists-portal-school-header
    [school]="juniorCampInfo.school?.name"
    [country]="juniorCampInfo.country"
    [subtitle]="juniorCampInfo.minAge | lxJuniorCampAges : juniorCampInfo.maxAge"
    [disclaimer]="includedInPackageNote"
    [schoolDescription]="juniorCampInfo.languages | lxJuniorCampsSchoolDescription"
    [company]="company"
    [applicationForms]="applicationForms"
  ></lx-price-lists-portal-school-header>
</div>
